import { createTestId } from 'utils';
import React, { Fragment, useContext } from 'react'
import { Menu, Transition } from "@headlessui/react";
import * as Icon from "react-feather"
import ReactCountryFlag from "react-country-flag"
import { useSelector } from 'react-redux';
import { IntlContext } from 'configuration/intl-context';

const LanguageDropDown = () => {

    const languages = useSelector(state => state.languages)
    const language = useSelector(state => state.language)
    const { switchLanguage } = useContext(IntlContext)

    return (
        <Menu>
            {({ open }) => (
                <>
                    <Menu.Button className="nav-link nav-icon">
                        <div>
                            <ReactCountryFlag countryCode={languages.filter(x => x.code == language).length > 0 ? languages.filter(x => x.code == language)[0].culture.split("-")[1] : "tr"} svg />
                        </div>
                    </Menu.Button>

                    <Transition
                        as={Fragment}
                        show={open}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items
                            static
                            className="dropdown-menu mt-4"
                        >
                            {languages.filter(x => x.code != language).map((item) => (
                                <Menu.Item
                                    as="button"
                                    key={item.id}
                                    data-testid={createTestId('menu', 'LanguageDropDown', 1)} onClick={() => { switchLanguage(item) }}
                                    className="dropdown-item"
                                >
                                    <ReactCountryFlag countryCode={item.culture.split("-")[1]} svg />
                                    {item.name}
                                </Menu.Item>
                            ))}

                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    );
}

export default LanguageDropDown